export const autoReminderCronLogsConstants = {
    GET_AUTO_REMINDER_CRON_LOGS_REQUEST: 'GET_AUTO_REMINDER_CRON_LOGS_REQUEST',
    GET_AUTO_REMINDER_CRON_LOGS_SUCCESS: 'GET_AUTO_REMINDER_CRON_LOGS_SUCCESS',
    GET_AUTO_REMINDER_CRON_LOGS_FAILURE: 'GET_AUTO_REMINDER_CRON_LOGS_FAILURE',
}